import { Card } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useCustomerValue } from "providers/CustomerContext";
import { useState,useEffect,useRef } from "react";
import { Link } from "react-router-dom";
import { getInventorySKUList,getCustomerCode,getVendorCodeFromCustomer,getZone,getLocation,getOLN,getMLN,getCartonID,getDistinctSKUCode,getDistinctSKUCategory,
  getDistinctSKUGroup,
  getDistinctSKUSubgroup,getPhysicalCountList,getPhysicalCountList2, retrievePhysicalCountList,retrievePhysicalCountException} from "services/data.inventory.service";
import { LoadingDialog } from "ui-components/Alert";
import { ListLayout } from "ui-components/Layout";
import ServerTable from "ui-components/tables/ServerTable";
import BasicTabs from "ui-components/tabs/BasicTabs";
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { createSO } from "services/data.outbound.service";
import { InboundLayout } from "ui-components/Layout";
import { InboundHeaderCard } from "ui-components/Layout";
import { FormTitle, DatePickerField, Text, SelectField } from "ui-components/Form";
import { Grid,Typography } from "@mui/material";
//import SO from "./components/SO";
//import { headerRender, headerValues, headerValidation } from "./physical-count-schema";
import { SelectFields } from "ui-components/Form";
import { Fieldset } from "ui-components/Form";
import switchButton from "assets/theme/components/form/switchButton";
import Switch from "@mui/material/Switch";
import { SwitchField,Texts } from "ui-components/Form";
import { TableCard } from "ui-components/Layout";
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import BasicTable from "ui-components/tables/BasicTable";
import { CustomSwitch } from "ui-components/CustomInput";
import { ReadonlyText } from "ui-components/Form";
import { Success, Error_ } from "ui-components/Alert";
import { useTeamValue } from "providers/TeamContext";

const tabs = ["Stock Available", "Out Of Stock", "Inactive"];

function AddPhysicalCount({zoneLocationAisle}) {
  const {permissions, allowAll} = useTeamValue();
  const addPermission =
    allowAll ||
    (Boolean(permissions["Physical Count"]) &&
      permissions["Physical Count"].findIndex((b) => b === "add") !== -1);
  const { customerCode } = useCustomerValue();
  const { vendorCode } = useState("");
  const [details, setDetails] = useState([]);
  const [alert, setAlert] = useState(null);
  const onError = (error) => {
    setAlert(<Error_ data={error} onChange={setAlert} />);
    setIsGenerating(false);
  };
  const [isGenerating, setIsGenerating] = useState(false);

  //added by leoliew
  const [criteriaCustomerVendor, setCriteriaCustomerVendor] = useState("Customer");
  const [criteriaZoneLocationAisle, setCriteriaZoneLocationAisle] = useState("Zone");
  const [criteriaZoneLocationAisle2, setCriteriaZoneLocationAisle2] = useState([]);
  const [criteriaSKUAttribute, setCriteriaSKUAttribute] = useState("");
  const [criteriaSortOrder, setcriteriaSortOrder] = useState("Ascending");
  const [temp,setTemp]=useState({freeze:false,showSystemQuantity:false,excludeQuarantineItem:false})
  const [pickers, setPickers] = useState([]);
  const [type, setType] = useState("EXCEPTION");
  const [list, setList] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState([]);
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [zones, setZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState([]);
  const [olns, setOLNs] = useState([]);
  const [selectedOLN, setSelectedOLN] = useState([]);
  const [mlns, setMLNs] = useState([]);
  const [selectedMLN, setSelectedMLN] = useState([]);
  const [cartonids, setCartonIDs] = useState([]);
  const [selectedCartonID, setSelectedCartonID] = useState([]);
  const [skucodes, setSKUCodes] = useState([]);
  const [selectedSKUCodes, setSelectedSKUCodes] = useState([]);
  const [skucategories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [skugroups, setSKUGroups] = useState([]);
  const [selectedSKUGroup, setSelectedSKUGroup] = useState([]);
  const [skusubgroups, setSKUSubgroups] = useState([]);
  const [selectedSKUSubgroup, setSelectedSKUSubgroup] = useState([]);

  if (zoneLocationAisle && zoneLocationAisle.length) {
    console.log(zoneLocationAisle.length);
  } else {
    console.log('Object is undefined or has no length property');
  }

  const columns = [
    {
      accessorKey: "documentNo",
      header: "Document No",
      width: 150,
    },
    {
      accessorKey: "warehouseCode",
      header: "Warehouse Code",
      width: 150,
    },
    {
      accessorKey: "zoneID",
      header: "Zone ID",
      width: 150,
    },
    {
      accessorKey: "locationID",
      header: "Location ID",
      width: 150,
    },
    {
      accessorKey: "customerCode",
      header: "Customer Code",
      width: 200,
      align: "right",
    },
    {
      accessorKey: "vendorCode",
      header: "Vendor Code",
      width: 150,
    },
    {
      accessorKey: "skuCode",
      header: "SKU Code",
      width: 150,
      align: "right",
    },
    {
      accessorKey: "quantity",
      header: "Quantity",
      width: 150,
      align: "right",
    },
  ];

  const createSOMutation = useMutation(createSO, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });

  const applyCriteriaSetting = (criteriaCustomerVendor,criteriaZoneLocationAisle2,criteriaSKUAttribute,criteriaSortOrder) => {
    resetVisibility();
    if (criteriaCustomerVendor !== null){
      console.log("criteriaCustomerVendor is not null");
      console.log(criteriaCustomerVendor);
      if (criteriaCustomerVendor.value == "1")
      {
        console.log("customer only");
        refetch();
        //show customer dropdownlist
        //populate customer dropdownlist data
      }
      else if (criteriaCustomerVendor.value == "2")
      {
        console.log("customer and vendor");
        setVendorVisible(true);
        refetch();
        refetchVendor();
        //show customer and vendor dropdownlist
        //populate customer and vendor dropdownlist data
      }
    };
    if (criteriaZoneLocationAisle2 !== null){
      console.log("criteriaZoneLocationAisle2 is not null");
      console.log(criteriaZoneLocationAisle2);
      if (criteriaZoneLocationAisle2.includes('Location'))
      {
        setLocationVisible(true);
        refetchLocation();
      }
      if (criteriaZoneLocationAisle2.includes('Zone'))
      {
        setZoneVisible(true);
        refetchZone();
      }
    };
    if (criteriaSKUAttribute !== null){
      console.log("criteriaSKUAttribute is not null");
      console.log(criteriaSKUAttribute);
      if (criteriaSKUAttribute.includes('OLN'))
      {
        setOLNVisible(true);
        console.log("i enter oln");
        refetchOLN();
      }
      else if (criteriaSKUAttribute.includes('MLN'))
      {
        setMLNVisible(true);
        console.log("i enter mln");
        refetchMLN();
      }
      else if (criteriaSKUAttribute.includes('Carton ID'))
      {
        setCartonIDVisible(true);
        console.log("i enter cartonid");
        refetchCartonID();
      }
      else if (criteriaSKUAttribute.includes('SKU Code'))
      {
        setSKUCodeVisible(true);
        console.log("i enter skucode");
        if (vendorCode === undefined) {
          refetchSKUCode(customerCode);
          console.log('1' );
        }
        else
        {
          refetchSKUCode(customerCode,selectedVendor);
          console.log('2' );
        }
        console.log(selectedVendor );
        
      }
      else if (criteriaSKUAttribute.includes('SKU Category'))
      {
        setSKUCategoryVisible(true);
        console.log("i enter cateogry");
        refetchCategory(customerCode,"123");
      }
      else if (criteriaSKUAttribute.includes('SKU Group'))
      {
        setSKUGroupVisible(true);
        console.log("i enter skugroup");
        refetchSKUGroup(customerCode,vendorCode);
      }
      else if (criteriaSKUAttribute.includes('SKU Subgroup'))
      {
        setSKUSubgroupVisible(true);
        console.log("i enter skusubgroup");
        refetchSKUSubgroup(customerCode,vendorCode);
      }
    };
    if (criteriaSortOrder !== null){
      console.log("criteriaSortOrder is not null");
    };
  };

  const { isFetching, refetch } = useQuery({
    queryKey: [ "customerOption",{ customerCode } ],
    queryFn: () =>
    getCustomerCode(),
    //getVendorCodeFromCustomer(customerCode),
    enabled: false,
    onSuccess: (data) => setCustomers(data.data.data),
    //onSuccess: (data) => setVendors(data.data.data),
    onError,
  });

  const { isFetchingExceptionList,refetch:refetchExceptionList } = useQuery({
    //queryKey: ["exceptionlist"],
    queryFn: () => getPhysicalCountList(),
    enabled: false,
    onSuccess: (data) => 
      {
        console.log(data);
        setList(data.data.data)
      },
  });

  // const { isFetchingExceptionList2,refetch:refetchExceptionList2 } = useMutation({
  //   queryKey: ["exceptionlist"],
  //   queryFn: () => getPhysicalCountList2({ 
  //     customerCode,
  //     vendorCode:selectedVendor,
  //     locationID:selectedLocation,
  //     zoneID:selectedZone,
  //     skuCode:selectedSKUCodes,
  //     category:selectedCategory,
  //     skuGroup:selectedSKUGroup,
  //     skuSubgroup:selectedSKUSubgroup,
  //     oln:selectedOLN,
  //     mln:selectedMLN,
  //     cartonID:selectedCartonID,
  //     freeze:temp.freeze,
  //     showSystemQuantity:temp.showSystemQuantity,
  //     hold:temp.excludeQuarantineItem,
  //     sortorder:criteriaSortOrder
  //    }),
  //   enabled: false,
  //   onSuccess: (data) => {
  //     console.log(data);
  //     const { pCountNo } = data.data; // Assuming the pCountNo is returned in the data object
  //     console.log("PCountNo:", pCountNo);
  //   retrievePhysicalCountList(pCountNo);
  //   //setList(data.data.data);
  // },
  // });

  const handleDownload = () => {
      retrievePhysicalCountException().then((response) => {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `PhysicalCountException.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  const getphysicalcountMutation = useMutation((requestdata) => getPhysicalCountList2(requestdata), {
    onMutate: () => {
      // Show loading dialog when the mutation starts
      setIsGenerating(true);
    },
    onSuccess: (data) => {
      console.log("returned data",data);
      if (data && data.data && data.data.pCountNo) {
      const { pCountNo } = data.data;
      console.log("PCountNo:", pCountNo);
      if (pCountNo =="SKU not found in this location")
      {
        setAlert(<Error_ content="SKU not found in this location." onChange={setAlert} />);
      }
      else
      {
        retrievePhysicalCountList(pCountNo).then((response)=> {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${pCountNo}.xlsx`);
        document.body.appendChild(link);
        link.click();
        });
        setAlert(<Success content="Physical Count generate successfully." onChange={setAlert} />);
      }  
    }
    else
    {
      //setAlert(<Error_ data={errors} onChange={setAlert} />);
      setAlert(<Error_ content="Please check the exception list below." onChange={setAlert} />);
      refetchExceptionList();
    }
    setIsGenerating(false);
      // queryClient.invalidateQueries(["exception-list"]);
      // setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });

  const ongetphysicalcountMutation = () => {
    setList([]);
    //const locationValue = locationText.trim() !== "" ? locationText : selectedLocation;
    const safeLocationText = locationText ?? "";
    const locationValue = safeLocationText.trim() !== "" ? safeLocationText : selectedLocation;
    console.log("inside on getphysicalcountmutation:");
    getphysicalcountMutation.mutate({ 
      customerCode,
      vendorCode:selectedVendor,
      locationID:locationValue,
      zoneID:selectedZone,
      skuCode:selectedSKUCodes,
      category:selectedCategory,
      skuGroup:selectedSKUGroup,
      skuSubgroup:selectedSKUSubgroup,
      oln:selectedOLN,
      mln:selectedMLN,
      cartonID:selectedCartonID,
      freeze:temp.freeze,
      showSystemQuantity:temp.showSystemQuantity,
      hold:temp.excludeQuarantineItem,
      sortorder:criteriaSortOrder
     });
  }

  const { isFetchingVendor, refetch:refetchVendor } = useQuery({
    queryKey: [ "vendorOption", { customerCode } ],
    queryFn: () =>
    getVendorCodeFromCustomer({
      customerCode
    }),
    enabled: false,
    onSuccess: (data) => setVendors(data.data.data),
    onError,
  });

  const { isFetchingLocation, refetch:refetchLocation } = useQuery({
    queryKey: [ "locationOption", { customerCode } ],
    queryFn: () =>
    getLocation({ active: true, customerCode }),
    enabled: false,
    onSuccess: (data) => setLocations(data.data.data.map(x=>x.locationID)),
    onError,
  });

  const { isFetchingZone, refetch:refetchZone } = useQuery({
    queryKey: [ "zoneOption", { customerCode } ],
    queryFn: () =>
    getZone({ active: true, customerCode }),
    enabled: false,
    onSuccess: (data) => setZones(data.data.data.map(x=>x.zoneID)),
    onError,
  });

  const { isFetchingOLN, refetch:refetchOLN } = useQuery({
    queryKey: [ "olnOption", { customerCode } ],
    queryFn: () =>
    getOLN({ customerCode }),
    enabled: false,
    onSuccess: (data) => setOLNs(data.data.data),
    onError,
  });

  const { isFetchingMLN, refetch:refetchMLN } = useQuery({
    queryKey: [ "MLNOption", { customerCode } ],
    queryFn: () =>
    getMLN({ customerCode }),
    enabled: false,
    onSuccess: (data) => setMLNs(data.data.data),
    onError,
  });

  const { isFetchingCartonID, refetch:refetchCartonID } = useQuery({
    queryKey: [ "CartonIDOption", { customerCode } ],
    queryFn: () =>
    getCartonID({ customerCode }),
    enabled: false,
    onSuccess: (data) => setCartonIDs(data.data.data),
    onError,
  });

  const { isFetchingSKUCode, refetch:refetchSKUCode } = useQuery({
    queryKey: [ "SKUCodeOption", { customerCode } , {selectedVendor} ],
    queryFn: () =>
    getDistinctSKUCode({
      customerCode,
      selectedVendor
    }),
    enabled: false,
    onSuccess: (data) => setSKUCodes(data.data.data),
    onError,
  });

  const { isFetchingCategory, refetch:refetchCategory } = useQuery({
    queryKey: [ "SKUCategoryOption", { customerCode }, {selectedVendor} ],
    queryFn: () =>
    getDistinctSKUCategory({
      customerCode,
      selectedVendor
    }),
    enabled: false,
    onSuccess: (data) => setCategories(data.data.data),
    onError,
  });

  const { isFetchingSKUGroup, refetch:refetchSKUGroup } = useQuery({
    queryKey: [ "SKUGroupOption", { customerCode }, {selectedVendor} ],
    queryFn: () =>
    getDistinctSKUGroup({
      customerCode,
      selectedVendor
    }),
    enabled: false,
    onSuccess: (data) => setSKUGroups(data.data.data),
    onError,
  });

  const { isFetchingSKUSubGroup, refetch:refetchSKUSubgroup } = useQuery({
    queryKey: [ "SKUSubgroupOption", { customerCode }, {selectedVendor} ],
    queryFn: () =>
    getDistinctSKUSubgroup({
      customerCode,
      selectedVendor
    }),
    enabled: false,
    onSuccess: (data) => setSKUSubgroups(data.data.data),
    onError,
  });

  // const onExport = () => {
  //   //setLoading(<LoadingDialog />);
  //   exportMutation.mutate(
  //     { customerCode, exceptionalType: type },
  //     {
  //       onSuccess: (data) => {
  //         const blob = new Blob([data.data]);
  //         const url = window.URL.createObjectURL(blob);
  //         const link = document.createElement("a");
  //         link.href = url;
  //         link.setAttribute("download", `${customerCode}_${type}.xlsx`);
  //         document.body.appendChild(link);
  //         link.click();
  //       },
  //     }
  //   );
  // };
  // const exportStatus = exportMutation.status === "loading";

  const [isVendorVisible, setVendorVisible] = useState(false);
  const [isZoneVisible, setZoneVisible] = useState(false);
  const [isLocationVisible, setLocationVisible] = useState(false);
  const [isSKUCodeVisible, setSKUCodeVisible] = useState(false);
  const [isSKUCategoryVisible, setSKUCategoryVisible] = useState(false);
  const [isSKUGroupVisible, setSKUGroupVisible] = useState(false);
  const [isSKUSubgroupVisible, setSKUSubgroupVisible] = useState(false);
  const [isOLNVisible, setOLNVisible] = useState(false);
  const [isMLNVisible, setMLNVisible] = useState(false);
  const [isCartonIDVisible, setCartonIDVisible] = useState(false);
  const [showGrid, setShowGrid] = useState(false);

  const resetVisibility = () => {
    setVendorVisible(false);
    setZoneVisible(false);
    setLocationVisible(false);
    setSKUCodeVisible(false);
    setSKUCategoryVisible(false);
    setSKUGroupVisible(false);
    setSKUSubgroupVisible(false);
    setOLNVisible(false);
    setMLNVisible(false);
    setCartonIDVisible(false);
  };

  useEffect(() => {
    console.log("Selected Vendor:", selectedVendor);
    // only reload SKU codes when the SKU Code filter is shown (skips the call on page load)
    if (isSKUCodeVisible) {
      refetchSKUCode();
    }
  }, [selectedVendor]);

  const [locationText, setLocationText] = useState(null);
  const [locationSelect, setLocationSelect] = useState(null);
  const locationTextRef = useRef(null);

  const handleLocationTextChange = (e) => {
    console.log("handle location text change");
    //console.log(e);
    
    // if (locationTextRef.current) {
    //   locationTextRef.current.value = e.target.value; // Manually reset field
    // }

    setLocationText(e.target.value);
    //console.log("locationtext=",locationText);
    if (e.target.value) {
      setSelectedLocation([]); // Clear selected locations if text is entered
      console.log("gt clear the data");
    }
  };

//   useEffect(() => {
//     if (selectedLocation.length > 0) {
//         setLocationText(""); // Ensure text field clears when selecting from dropdown
//         console.log("Text field cleared after selecting location");
//     }
// }, [selectedLocation]);

   useEffect(() => {
     console.log("Updated locationText:", locationText);
   }, [locationText]); // Runs when locationText changes

//  useEffect(() => {
//   console.log("locationTextRef:", locationTextRef);
//   console.log("locationText:", locationText);
//   if (locationTextRef.current && locationText === "") {
//     console.log("check gt trigger useeffect in textref or not:", locationText);
//     locationTextRef.current.value = ""; // 🔹 Manually update the input field
//   }
// }, [locationText]); // 🔹 Runs whenever locationText changes
  // useEffect(() => {
  //   if (locationTextRef.current) {
  //     locationTextRef.current.focus();
  //   }
  // }, [locationText]);



  
  const handleLocationSelectChange = (e, v) => {
    console.log("handle location select change");
    console.log("Selected Location:", v);
    setSelectedLocation(v);
    //setLocationSelect(v);
    if (v && v.length > 0) {
      setLocationText(null); // Clear text input if selecting from dropdown
      //setLocationText(e.target.value);
      // if (locationTextRef.current) {
      //   locationTextRef.current.value = ""; // 🔹 Manually update the UI
      // }
      console.log("gt clear the data text");
      //console.log("locationtextafterclear",locationText);
    }
  };

  const filteredOptions = locations.filter(loc => !selectedLocation.includes(loc));

  return (
    <>
    {isFetching && isFetchingVendor && isFetchingLocation && isFetchingZone && isFetchingOLN && isFetchingMLN && isFetchingCartonID && isFetchingSKUCode && isFetchingCategory && isFetchingSKUGroup && isFetchingSKUSubGroup && <LoadingDialog />}
    {isGenerating && <LoadingDialog title="Generating Physical Count" />}
    <InboundLayout lg={12}>
      {alert}
      {/* codebelowforseethedatainswitch */}
      {/* {JSON.stringify(temp)}
      {JSON.stringify(criteriaCustomerVendor)}
      {JSON.stringify(criteriaZoneLocationAisle)}
      {JSON.stringify(criteriaSKUAttribute)}
      {JSON.stringify(criteriaSortOrder)}
      {JSON.stringify(criteriaZoneLocationAisle2)} */}
      <InboundHeaderCard>
        <FormTitle title={"Generate Physical Count"} />
        <form noValidate>
          {/* <switchButton>123</switchButton> */}
          {showGrid && (
          <Grid container spacing={3}>
          <Grid item xs={4}>
          <CustomSwitch
            field={{ name: "freeze", label: "Freeze", checked: temp.freeze }}
            onChange={() => setTemp({...temp,freeze:!temp.freeze})}
          />
          </Grid>
          <Grid item xs={4}>
          <CustomSwitch
            field={{ name: "Show System Quantity", label: "Show System Quantity", checked: temp.showSystemQuantity }}
            onChange={() => setTemp({...temp,showSystemQuantity:!temp.showSystemQuantity})}
          />
          </Grid>
          <Grid item xs={4}>
          <CustomSwitch
            field={{ name: "Exclude Quarantine Item", label: "Exclude Quarantine Item", checked: temp.excludeQuarantineItem }}
            onChange={() => setTemp({...temp,excludeQuarantineItem:!temp.excludeQuarantineItem})}
          />
          </Grid>
          </Grid>
        )}
          {/* <SwitchField/> */}
          {/* <SwitchField field={{ 'abc': 'def' }} /> */}
          <Fieldset label="Criteria Setting" sx={{ marginBottom: "1.5rem" }}>
            <Grid container spacing={3}>
              <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "Customer/Vendor",
                    value: criteriaCustomerVendor,
                    errors: {},
                  }}
                  options={[
                    //"Customer", "Customer & Vendor"
                    { label: "Customer", value: "1" },
                    { label: "Customer & Vendor", value: "2" }
                  ]}
                  onChange={(e, v) => setCriteriaCustomerVendor(v)}
                />
              </Grid>
              {/* <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "Zone/Location/Aisle",
                    value: criteriaZoneLocationAisle,
                    errors: {},
                  }}
                  options={["Zone", "Location", "Aisle"]}
                  onChange={(e, v) => setCriteriaZoneLocationAisle(v)}
                />
              </Grid> */}
              <Grid item xs={3}>
            <SelectFields
              field={{ name: "", label: "Zone/Location", value: criteriaZoneLocationAisle2, errors: {}, multiple: true }}
              options={["Zone", "Location"]}
              onChange={(e, v) => setCriteriaZoneLocationAisle2(v)}
            />
          </Grid>
              <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "SKUAttributes",
                    value: criteriaSKUAttribute,
                    errors: {},
                  }}
                  options={[
                    "SKU Code",                  
                    "SKU Category",
                    "SKU Group",
                    "SKU Subgroup",
                    "OLN",
                    "Carton ID",
                    "MLN",
                  ]}
                  onChange={(e, v) => setCriteriaSKUAttribute(v)}
                />
              </Grid>
              <Grid item xs={3}>
                <SelectFields
                  field={{ name: "", label: "Sort Order", value: criteriaSortOrder, errors: {} }}
                  options={["Ascending", "Descending"]}
                  onChange={(e, v) => setcriteriaSortOrder(v)}
                />
              </Grid>
            </Grid>
          </Fieldset>
          <Grid container spacing={12}>
            <Grid item xs={3}>
              <MDButton color="info" variant="gradient" onClick={() => applyCriteriaSetting(criteriaCustomerVendor, criteriaZoneLocationAisle2, criteriaSKUAttribute, criteriaSortOrder)}>
              Apply Criteria Setting
              </MDButton>
            </Grid>
          </Grid>
          <br></br>
          <Fieldset label="Filter" sx={{ marginBottom: "1.5rem" }}>
            <Grid container spacing={3}>
              <Grid item xs={3}>
              <ReadonlyText
              field={{
                label: "Customer Code",
                name: "customerCode",
                value: customerCode,
              }}
            />
                 {/* <SelectFields
                  field={{ name: "", label: "Customer2", value: "", errors: {} }}
                  options={customers}
                  onChange={(e, v) => populatedCustomerVendor(v)}
                  disabled
                /> */}
              </Grid>
              {isVendorVisible && (
              <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "Vendor",
                    value: selectedVendor,
                    errors: {},
                    multiple: true
                  }}
                  options={vendors}
                  onChange={(e, v) => setSelectedVendor(v)}
                />
              </Grid>
              )}
              {isZoneVisible && (
              <Grid item xs={3}>
                <SelectFields
                  field={{ name: "", label: "Zone", value: selectedZone, errors: {},multiple: true }}
                  options={zones}
                  onChange={(e, v) => setSelectedZone(v)}
                />
              </Grid>
              )}
              {isLocationVisible && (
              <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "Location",
                    value: selectedLocation ?? null,
                    errors: {},
                    multiple: true
                  }}
                  options={filteredOptions}
                  onChange={handleLocationSelectChange}
                  //disabled={!!locationText}
                />
              </Grid>
              )}
              {/* <Grid item xs={4}>
                <SelectFields
                  field={{ name: "", label: "Aisle", value: "", errors: {} }}
                  options={["Aisle"]}
                  onChange={(e, v) => setCriteriaZoneLocationAisle(v)}
                />
              </Grid> */}
              {isOLNVisible && (
              <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "OLN",
                    value: selectedOLN,
                    errors: {},
                    multiple: true
                  }}
                  options={olns}
                  onChange={(e, v) => setSelectedOLN(v)}
                />
              </Grid>
              )}
              {isMLNVisible && (
              <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "MLN",
                    value: selectedMLN,
                    errors: {},
                    multiple: true
                  }}
                  options={mlns}
                  onChange={(e, v) => setSelectedMLN(v)}
                />
              </Grid>
              )}
              {isCartonIDVisible && (
              <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "CartonID",
                    value: selectedCartonID,
                    errors: {},
                    multiple: true
                  }}
                  options={cartonids}
                  onChange={(e, v) => setSelectedCartonID(v)}
                />
              </Grid>
              )}
              {isSKUCodeVisible && (
              <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "SKU Code",
                    value: selectedSKUCodes,
                    errors: {},
                    multiple: true,
                  }}
                  options={skucodes}
                  onChange={(e, v) => setSelectedSKUCodes(v)}
                />
              </Grid>
              )}
              {isSKUCategoryVisible && (
              <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "SKU Category",
                    value: selectedCategory,
                    errors: {},
                    multiple: true
                  }}
                  options={skucategories}
                  onChange={(e, v) => setSelectedCategory(v)}
                />
              </Grid>
              )}
              {isSKUGroupVisible && (
              <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "SKU Group",
                    value: selectedSKUGroup,
                    errors: {},
                    multiple: true
                  }}
                  options={skugroups}
                  onChange={(e, v) => setSelectedSKUGroup(v)}
                />
              </Grid>
              )}
              {isSKUSubgroupVisible && (
              <Grid item xs={3}>
                <SelectFields
                  field={{
                    name: "",
                    label: "SKU SubGroup",
                    value: selectedSKUSubgroup,
                    errors: {},
                    multiple: true
                  }}
                  options={skusubgroups}
                  onChange={(e, v) => setSelectedSKUSubgroup(v)}
                />
              </Grid>
              )}
              {isLocationVisible && (
              <Grid item xs={12}>
                <Typography color="error" variant="body2">
        ⚠️ You can only use one location input (either text field or dropdown).
      </Typography>
                <Texts 
            field={{ name: "locationText", label: "Location (separate by comma)",value:locationText , maxLength: 5000 }}
            onChange={handleLocationTextChange}
            
            //disabled={selectedLocation.length > 0}
          />
              </Grid>
              )}
              
            </Grid>
          </Fieldset>
          <Grid container spacing={12}>
            <Grid item xs={3}>
              <MDButton color="info" variant="gradient" onClick={() => ongetphysicalcountMutation()} disabled={!addPermission}>
                Generate Physical Count
              </MDButton>
            </Grid>
            {/* <Grid item xs={3}>
              <MDButton color="info" variant="gradient" onClick={refetchExceptionList}>
                manual generate exception
              </MDButton>
            </Grid> */}
          </Grid>
          <br></br>
          <FormTitle title={"Physical Count Exception Report"} />
          <TableCard sx={{ marginTop: 4 }}>
            <Grid sx={{ padding: "10px" }} container spacing={3}>
              <Grid item>
                <MDButton
                  color="info"
                  variant="gradient"
                  onClick={handleDownload}
                  disabled={customerCode === null}
                >
                  Export
                </MDButton>
              </Grid>
              <Grid item>
                <FormControl>
                  {/* <FormLabel>type</FormLabel> */}
                  <RadioGroup
                    row
                    onChange={(e) => {
                      setType(e.target.value);
                    }}
                  >
                    {/* <FormControlLabel
                  labelPlacement="left"
                  value="EXCEPTION"
                  label="Preallocate Exception"
                  control={<Radio checked={type === "EXCEPTION"} />}
                />
                <FormControlLabel
                  labelPlacement="left"
                  value="FAILED"
                  label="Allocation Failed"
                  control={<Radio checked={type === "FAILED"} />}
                /> */}
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
            <BasicTable data={list} columns={columns} />
          </TableCard>
        </form>
      </InboundHeaderCard>

      {/* <Detail {...detailProps} /> */}
      {/* <InboundSubmitButton label="Submit" onClick={onSubmit} disabled={isSubmitting} /> */}
    </InboundLayout>
    </>
  );
}

export default AddPhysicalCount;
